module.exports = __webpack_public_path__ + "img/store_YT_brown.38ccf51c.svg";